import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PersonalInformationOwnerType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';
import { PatchDamagedUserInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedUserInformation/patchDamagedUserInformationQueryFunction';

type MutationVariables = {
  id: string;
  formData: PersonalInformationOwnerType;
  damaged_id: string;
};

export const PatchDamagedUserInformationQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => ({
  mutationKey: ['patch-Culprit-user-Information'],
  mutationFn: ({ id, formData, damaged_id }: MutationVariables) =>
    PatchDamagedUserInformationQueryFunction(id, formData, damaged_id),
});
